module.exports = __webpack_public_path__ + "static/img/dept.42edf2dc.svg";